import {authHeader} from '../_helpers'
import axios from 'axios'
import {router} from '../router'

export const userService = {
  login,
  googleLogin,
  logout,
  getAll,
  resetPwd
}

export const API_URL = process.env.API_URL

function login (username, password) {
  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({username, password})
  }

  return fetch(`${API_URL}/user_login/`, requestOptions)
    .then(handleLoginResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user))
      }

      return user
    })
}
function resetPwd (password, token) {
  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({password})
  }

  return fetch(`${API_URL}/reset_password/${token}`, requestOptions)
    // .then(handleLoginResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      // if (user.token) {
      //   // store user details and jwt token in local storage to keep user logged in between page refreshes
      //   localStorage.setItem('user', JSON.stringify(user))
      // }
      router.push('/login')
      return user
    })
}

function googleLogin (username, avatar) {
  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({username, avatar})
  }
  return fetch(`${API_URL}/googlelogin/`, requestOptions)
    .then(handleLoginResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      if (user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user))
      }

      return user
    })
}
function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('vuex')
  localStorage.clear()
  // localStorage.removeItem('user')
}

function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`/users`, requestOptions).then(handleLoginResponse)
}

function handleLoginResponse (response) {

  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        // location.reload(true)
      }

      // const error = (data && data.message) || response.statusText
      const error = response.status === 401 ? 'Неверные имя пользователя или пароль' : 'Что-то пошло не так'
      return Promise.reject(error)
    }

    return data
  })
}
export function handleResponse (response) {

  if (!response.response.ok) {
      if (response.response.status === 401) {
        // auto logout if 401 response returned from api
        logout()
        location.reload(true)
      }
      const error = response.response.statusText
      return Promise.reject(error)
    }
  else return true
}


export function authenticate (userData) {
  return axios.post(`${API_URL}/login/`, userData)
}

export function fetchPlaces () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }
  return axios.get(`${API_URL}/api/places`, requestOptions).catch(handleResponse)
}

export function fetchProjects () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }
  return axios.get(`${API_URL}/api/projects`, requestOptions).catch(handleResponse)
}
export function fetchProfiles () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }
  return axios.get(`${API_URL}/api/profiles`, requestOptions).catch(handleResponse)
}
export function fetchCustomerGroups () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }
  return axios.get(`${API_URL}/api/groups`, requestOptions).catch(handleResponse)
}

export function fetchUsers () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }
  return axios.get(`${API_URL}/api/users`, requestOptions).catch(handleResponse)
}

export function fetchProducts (params) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: params && params['showDeleted'] ? params['showDeleted']: 0,
      fetchAll:  params && params['fetchAll'] ? params['fetchAll']: false,
    }
  }

  return axios.get(`${API_URL}/api/products`, requestOptions).catch(handleResponse)
}
export function fetchDirections () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0,
      fetchAll: true
    }
  }

  return axios.get(`${API_URL}/api/directions`, requestOptions).catch(handleResponse)
}
export function fetchTests () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0,
      fetchAll: true
    }
  }

  return axios.get(`${API_URL}/api/tests`, requestOptions).catch(handleResponse)
}

export function fetchConsultings () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0,
      fetchAll: true
    }
  }

  return axios.get(`${API_URL}/api/consultings`, requestOptions).catch(handleResponse)
}

export function fetchProductTypes () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }

  return axios.get(`${API_URL}/api/productstype`, requestOptions).catch(handleResponse)
}
export function fetchDiseaseTypes () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }

  return axios.get(`${API_URL}/api/diseasestype`, requestOptions).catch(handleResponse)
}
export function fetchConsultationTypes () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }
  return axios.get(`${API_URL}/api/consultstype`, requestOptions).catch(handleResponse)
}
export function fetchGlobalIndicators () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }

  return axios.get(`${API_URL}/api/globalindicators`, requestOptions).catch(handleResponse)
}
//
// export function fetchClassificators () {
//   const requestOptions = {
//     method: 'GET',
//     headers: authHeader(),
//     params: {
//       showDeleted: 0
//     }
//   }
//
//   return axios.get(`${API_URL}/api/classificators`, requestOptions).catch(handleResponse)
// }

export function fetchCustomers () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      showDeleted: 0
    }
  }

  return axios.get(`${API_URL}/api/customers`, requestOptions).catch(handleResponse)
}

export function fetchRoles () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return axios.get(`${API_URL}/api/roles`, requestOptions).catch(handleResponse)
}


export function fetchReports () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return axios.get(`${API_URL}/api/reports`, requestOptions).catch(handleResponse)
}

const initialState = {
  // single source of data
  surveys: [],
  currentSurvey: {},
  user: {},
  jwt: '',
  backend: `${API_URL}`,
  places: [],
  classificators: [],
  productTypes: [],
  consultationTypes:[],
  globalIndicators:[],
  diseaseTypes: [],
  users: [],
  products: [],
  tests: [],
  consultings: [],
  directions: [],
  roles: [],
  place: [],
  customerGroups: [],
  projects: [],
  profiles: [],
}

/* eslint-disable */

export const getters = {
  // reusable data accessors
  isAuthenticated (state) {
    return isValidJwt(state.jwt.token)
  },
  userData (state) {
    return state.tableData.currentUser
  }

}
/* eslint-enable */

export const outreachReport = {
  namespaced: true,
  state: null
}


export const tableData = {
  namespaced: true,
  state: initialState,
  actions: {
    loadPlaces ({commit}) {
      return fetchPlaces()
        .then((response) => {
          commit('setPlaces', {places: response.data})
        })
    },
    loadProjects ({commit}) {
      return fetchProjects()
        .then((response) => {
          commit('setProjects', {projects: response.data})
        })
    },
    loadProfiles ({commit}) {
      return fetchProfiles()
        .then((response) => {
          commit('setProfiles', {profiles: response.data})
        })
    },
    loadCustomerGroups ({commit}) {
      return fetchCustomerGroups()
        .then((response) => {
          commit('setCustomerGroups', {customerGroups: response.data})
        })
    },
    loadRoles ({commit}) {
      return fetchRoles()
        .then((response) => {
          commit('setRoles', {roles: response.data})
        })
    },
    loadProductTypes (context) {
      return fetchProductTypes()
        .then((response) => {
          context.commit('setProductTypes', {productTypes: response.data})
        })
    },
    loadDiseaseTypes (context) {
      return fetchDiseaseTypes()
        .then((response) => {
          context.commit('setDiseaseTypes', {diseaseTypes: response.data})
        })
    },
    loadConsultationTypes (context) {
      return fetchConsultationTypes()
        .then((response) => {
          context.commit('setConsultationTypes', {consultationTypes: response.data})
        })
    },
    loadGlobalIndicators (context) {
      return fetchGlobalIndicators()
        .then((response) => {
          context.commit('setGlobalIndicators', {globalIndicators: response.data})
        })
    },
    // loadClassificators (context) {
    //   return fetchClassificators()
    //     .then((response) => {
    //       context.commit('setClassificators', {classificators: response.data})
    //     })
    // },
    loadProducts: async function (context, showDeleted) {
      let response = await fetchProducts(showDeleted)
      context.commit('setProducts', {products: response.data})
    },
    loadDirections: async function (context) {
      let response = await fetchDirections()
      context.commit('setDirections', {directions: response.data})
    },
    loadTests: async function (context) {
      let response = await fetchTests()
      context.commit('setTests', {tests: response.data})
    },
    loadConsultings (context) {
      return fetchConsultings()
        .then((response) => {
          context.commit('setConsultings', {consultings: response.data})
        })
    },
    loadUsers (context) {
      return fetchUsers()
        .then((response) => {
          context.commit('setUsers', {users: response.data})
        })
    },
    loadReports (context) {
      return fetchReports()
        .then((response) => {
          // //console.log(response)
          context.commit('setReports', {reports: response.data})
        })
    },
    loadUser (context) {
      return  context.commit('setCurrentUser', {currentUser: JSON.parse(localStorage.getItem('user'))})
    }
  },
  mutations: {
    setPlaces (state, payload) {
      state.places = payload.places
    },
    setProjects (state, payload) {
      state.projects = payload.projects
    },
    setProfiles (state, payload) {
      state.profiles = payload.profiles
    },
    setCustomerGroups (state, payload) {
      state.customerGroups = payload.customerGroups
    },
    setRoles (state, payload) {
      state.roles = payload.roles
    },
    setProductTypes (state, payload) {
      state.productTypes = payload.productTypes
    },
    setDiseaseTypes (state, payload) {
      state.diseaseTypes = payload.diseaseTypes
    },
    setConsultationTypes (state, payload) {
      state.consultationTypes = payload.consultationTypes
    },
    setGlobalIndicators (state, payload) {
      state.globalIndicators = payload.globalIndicators
    },
    setProducts (state, payload) {
      state.products = payload.products
    },
    setDirections (state, payload) {
      state.directions = payload.directions
    },
    setTests (state, payload) {
      state.tests = payload.tests
    },
    setConsultings (state, payload) {
      state.consultings = payload.consultings
    },
    setUsers (state, payload) {
      state.users = payload.users
    },
    setUserData (state, payload) {
      state.userData = payload.userData
    },
    // setClassificators (state, payload) {
    //   state.classificators = payload.classificators
    // },
    setReports (state, payload) {
      state.reports = payload.reports
            // //console.log(state, payload)

    },
    setCurrentUser (state, payload) {
      state.currentUser = payload.currentUser
    },
    setJwtToken (state, payload) {
      localStorage.token = payload.jwt.token
      state.jwt = payload.jwt
    }
  }
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js